import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "estate-description" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between gap-3 text-start" }
const _hoisted_5 = { class: "segment-btn-group mt-2 mb-4" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_11 = { class: "float-end" }
const _hoisted_12 = {
  key: 0,
  disabled: "",
  class: "btn btn-lg btn-outline-primary align-middle"
}
const _hoisted_13 = ["title"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SyncDialog = _resolveComponent("SyncDialog")!
  const _component_NotSubmittedDataDialog = _resolveComponent("NotSubmittedDataDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('form.leadingParagraph')), 1),
          _renderSlot(_ctx.$slots, "actions")
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentConfigurations, (segment, segmentIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: segmentIndex }, [
              (_ctx.accessibleSegments.includes(segmentIndex))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: segment.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(segment.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(segment.label), 1))
            ], 64))
          }), 128)),
          (_ctx.lastKnownEstimateState.calculationUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.lastKnownEstimateState.calculationUrl
              }, _toDisplayString(_ctx.$t('form.segments.calculation')), 9, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('form.segments.calculation')), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.errorMessage !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentConfigurations, (segmentConfig, index) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: segmentConfig.path
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(segmentConfig.component), _mergeProps({ ref_for: true }, segmentConfig.props, {
              estateType: _ctx.estimate.estateType,
              ref_for: true,
              ref: (el) => _ctx.setSegmentRef(index, el)
            }), null, 16, ["estateType"]))
          ])), [
            [_vShow, _ctx.$route.path === segmentConfig.path]
          ])
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("button", _hoisted_12, [
                _cache[3] || (_cache[3] = _createElementVNode("span", {
                  class: "spinner-border spinner-border-sm me-2 align-middle",
                  role: "status"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('form.navigation.loading')) + " ... ", 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.showFinishButton && _ctx.canCreateEstimate())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.lastKnownEstimateState.calculationUrl === null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["btn btn-lg", {'disabled': ! _ctx.online, 'btn-primary': _ctx.isLastSegment(), 'btn-outline-primary': !_ctx.isLastSegment()}]),
                            title: ! _ctx.online ? _ctx.$t('form.errors.cannotCreateEstimateOffline') : null,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.withSpinner(_ctx.createEstimate())))
                          }, _toDisplayString(_ctx.$t('form.navigation.createEstimate')), 11, _hoisted_13))
                        : (_ctx.isLastSegment())
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: _ctx.lastKnownEstimateState.calculationUrl,
                              class: "btn btn-lg btn-primary"
                            }, _toDisplayString(_ctx.$t('form.navigation.goToEstimate')), 9, _hoisted_14))
                          : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (! _ctx.isLastSegment())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-lg btn-primary ms-2",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitSegmentAndContinue && _ctx.submitSegmentAndContinue(...args)))
                    }, _toDisplayString(_ctx.$t('form.navigation.continue')), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ]),
        (_ctx.currentSegment > 0 && _ctx.segmentConfigurations[_ctx.currentSegment - 1])
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: _ctx.segmentConfigurations[_ctx.currentSegment - 1].path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.navigation.previous')) + " - " + _toDisplayString(_ctx.segmentConfigurations[_ctx.currentSegment - 1].label), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_SyncDialog, {
      "offline-manager": _ctx.offlineManager,
      "last-known-estimate-state": _ctx.lastKnownEstimateState,
      onSync: _cache[2] || (_cache[2] = ($event: any) => (_ctx.lastKnownEstimateState = $event)),
      ref: "syncDialog"
    }, null, 8, ["offline-manager", "last-known-estimate-state"]),
    _createVNode(_component_NotSubmittedDataDialog, { ref: "notSubmittedDataDialog" }, null, 512)
  ]))
}